import styled from "styled-components";
import YungLeanStarzCover from "assets/YungLeanStarzCover.png";
import { FormattedMessage } from "react-intl";
import React, { useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useRelease } from "../hooks/useRelease";

interface SummaryProps {
  coverUrl?: string,
}

export const Summary: React.FC<SummaryProps> = ({coverUrl  }) => {


  return (
    <Container>
      
        <Cover>
          <PreviewImage src={coverUrl} alt="Cover art" />
        </Cover>
      
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: 334px;
  border-radius: 30px;
  background-color: ${props => props.theme.palette.background.primary};
  justify-content: center;
  align-items: center;
`
const Title = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #000000;
`
const Cover = styled.div`
  width: 300px;
  height: 300px;
  border-radius: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

  overflow: hidden;
  background: #ffffff;
`;

const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

  object-fit: cover;
`;

const Loading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;